import { useEffect } from "react";
import {
  Autocomplete,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEventManagementStore } from "@/stores/eventManagementStore";
import { useOrgDashboardStore } from "@/stores/orgDashboardStore";

export const TrainingOrgAutocomplete = () => {
  const {
    trainingOrganizations,
    fetchTrainingOrganizations,
    selectedTrainingOrganization,
    setSelectedTrainingOrganization,
  } = useEventManagementStore();
  const { setSelectedOrganization } = useOrgDashboardStore();

  const theme = useTheme();
  const isViewportMediumOrLarger = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    fetchTrainingOrganizations();
  }, [fetchTrainingOrganizations]);

  return (
    <Autocomplete
      id={"training-org-autocomplete"}
      getOptionLabel={(option) => option.name}
      options={trainingOrganizations}
      value={selectedTrainingOrganization}
      onChange={(_, newValue) => {
        // setSelectedTrainingOrganization owns the routing: ERC supervisors land
        // on the User Permissions page rather than Events.
        setSelectedTrainingOrganization(newValue);
        setSelectedOrganization(null);
      }}
      fullWidth
      clearIcon={null}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={"Select Training Org."}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            sx: isViewportMediumOrLarger
              ? {
                  color: "white",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:focus .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                }
              : {},
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: isViewportMediumOrLarger ? { color: "white" } : {},
          }}
        />
      )}
      sx={
        isViewportMediumOrLarger
          ? {
              color: "white",
              "& .MuiAutocomplete-option": {
                color: "black",
                "&:hover": { color: "white" },
              },
              "& .MuiAutocomplete-input": { color: "white" },
              "& .MuiSvgIcon-root": {
                color: "white",
                "&:hover": { color: "white" },
              },
            }
          : {}
      }
    />
  );
};
